<template>
  <div class="container container--narrow pdt-50 pdb-50">
      <div class="t-subtitle6 font-r  t-line-h-26 d-flex -align-items-center">
        {{ question.number }}. {{ question.contents.text }}
        <span class="t-color-mainBtn" v-if="question.essential">*</span>
      </div>
      <div class="mgt-24" v-if="question.contents && question.contents.image">
          <img :src="question.contents.image" alt="" class="b-radius4 survey-banner ">
      </div>
      <div class="mgt-24">
          <label
              class="mdc-text-field mdc-text-field--outlined mdc-text-field--textarea w-full customize-textfield--outlined mdc-text-field--disabled disabled--Updated"
              data-mdc-auto-init="MDCTextField">
              <span class="mdc-text-field__ripple"></span>
              <textarea
                  class="mdc-text-field__input t-body6 font-r  pdl-15  pdr-24 pdb-32 t-line-h-26 l-spacing2"
                  :value="question.textResponse"
                  rows="3"
                  cols="10" maxlength="300" @keyup='charCount()' disabled></textarea>
              <span id="label" class="mdc-floating-label"></span>
              <span class="mdc-line-ripple"></span>
          <div class="mdc-text-field-helper-line w-full pdr-8 pdb-8">
          </div>
          </label> 
              <div class="mdc-text-field-character-counter t-helper t-color-bodyGrayA t-right font-r t-color-textfieldDisabledText">{{totalcharacter}} / 300</div>
      </div>
      <div class="mdc-card mgt-24 pda-24" v-if="question.text.feedback && eachViewFeedback">
          <div class="t-subtitle3 font-m">{{ $t("738") }}</div>
          <div class="mgt-8 t-body1 t-color-bodyGrayA t-line-h-24 font-r">
              {{ question.text.feedback }}
          </div>
      </div>
      <div class="mgt-50"></div>
  </div>
</template>


<script>
/**
 * 설문 - 단답형 문항 피드백 컴포넌트(survey - short answer question feedback component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
export default {
  props: ["question", "eachViewFeedback"],
  data() {
		return {
			totalcharacter:0,
			shortans:''
		};
	},

    mounted() {
        this.charCount()
    },

    methods: {
        charCount: function(){
             
            let char = this.question.textResponse.length;
            //let ans = shortans.length;
            //limit = 300;
            //console.log('sdasd',char)
            this.totalcharacter = char;

        },
    }
};


</script>